module.exports = __webpack_public_path__ + "static/media/gal0030.98dc6aa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal00/gal0030.jpg
// module id = 386
// module chunks = 0